<template>
  <v-layout column >
    <v-flex>
      <v-layout>
        <v-flex class="mt-3 xs12 sm6">
          <v-select
            v-model="selectedAction"
            :items="actions"
            label="Select action"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="selectedAction === 'transfer'">
      <transfer />
    </v-flex>
    <v-flex v-if="selectedAction === 'activate'">
      <activate />
    </v-flex>
    <v-flex v-if="selectedAction === 'deactivate'">
      <deactivate />
    </v-flex>
  </v-layout>
</template>

<script>
  import Transfer from './Transfer.vue'
  import Deactivate from './Deactivate.vue'
  import Activate from './Activate.vue'
  export default {
    name: 'ManageEmployee',
    components: {Activate, Deactivate, Transfer},
    props: {},
    data: () => ({
      selectedAction: 'transfer',
      actions: [
        { text: 'Transfer Employee', value: 'transfer' },
        { text: 'Activate Employee', value: 'activate' },
        { text: 'Deactivate Employee', value: 'deactivate' }
      ]
    }),
    computed: {},
    created () {},
    methods: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/views/manager-actions/ManageEmployee.vue